import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/fonts/Inter/inter.css';
import './assets/scss/global.scss';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import ContextState from './context/ContextStates';

if (process.env.NODE_ENV === 'development') {
	(async () => {
		const { default: setupLocatorUI } = await import('@locator/runtime');
		setupLocatorUI();
	})();
}

Sentry.init({
	dsn: 'https://14d09b3d5ae94960918100153b12375c@o1175389.ingest.sentry.io/4504718414381056',
	integrations: [new BrowserTracing()],

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 0.5,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<BrowserRouter>
		<ContextState>
			<App />
		</ContextState>
	</BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
